import { render, staticRenderFns } from "./commonTab.vue?vue&type=template&id=83c85438&scoped=true&"
import script from "./commonTab.vue?vue&type=script&lang=js&"
export * from "./commonTab.vue?vue&type=script&lang=js&"
import style0 from "./commonTab.vue?vue&type=style&index=0&id=83c85438&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83c85438",
  null
  
)

export default component.exports